module.exports = __webpack_public_path__ + "static/media/Mr-Ms.b324ed35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/Mr-Ms.png
// module id = 301
// module chunks = 10